'use client';

import { PropsWithChildren } from 'react';

import { AppInitialState } from '@/store';

import PageWrapper from '../../PageWrapper';
import StoreProvider from '../../StoreProvider';

const PageClientProvider = ({
	customMainId,
	hideAcceptCookiesModal,
	analyticsPageName,
	initialState,
	locale,
	messages,
	children,
}: PropsWithChildren<{
	customMainId?: string;
	hideAcceptCookiesModal?: boolean;
	analyticsPageName: string;
	initialState: AppInitialState;
	locale: string;
	messages: Record<string, string>;
}>) => {
	return (
		<StoreProvider initialState={initialState}>
			<PageWrapper
				customMainId={customMainId}
				hideAcceptCookiesModal={hideAcceptCookiesModal}
				analyticsPageName={analyticsPageName}
				locale={locale}
				messages={messages}
			>
				{children}
			</PageWrapper>
		</StoreProvider>
	);
};

export default PageClientProvider;
